export type Rng = () => number

export const hashString = (input: string): number => {
    let h1 = 0xdeadbeef ^ input.length
    let h2 = 0x41c6ce57 ^ input.length

    for (let index = 0; index < input.length; index++) {
        const code = input.charCodeAt(index)
        h1 = Math.imul(h1 ^ code, 2654435761)
        h2 = Math.imul(h2 ^ code, 1597334677)
    }

    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909)
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909)

    return (h1 ^ h2) >>> 0
}

export const mixSeed = (a: number, b: number): number => {
    let hash = Math.imul(a ^ 0x9e3779b9, 0x85ebca6b) ^ Math.imul((b + 0x7f4a7c15) | 0, 0xc2b2ae35)
    hash ^= hash >>> 16
    hash = Math.imul(hash, 0x45d9f3b)
    hash ^= hash >>> 16
    hash = Math.imul(hash, 0x45d9f3b)
    hash ^= hash >>> 16

    return hash >>> 0
}

export const createRng = (seed: number): Rng => {
    let state = seed >>> 0

    return (): number => {
        state = (state + 0x6d2b79f5) >>> 0
        let value = state
        value = Math.imul(value ^ (value >>> 15), value | 1)
        value ^= value + Math.imul(value ^ (value >>> 7), value | 61)

        return ((value ^ (value >>> 14)) >>> 0) / 4294967296
    }
}

export const normal = (rng: Rng): number => {
    let u = rng()
    if (u < 1e-12) u = 1e-12
    const v = rng()

    return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v)
}

export const between = (rng: Rng, min: number, max: number): number => min + (max - min) * rng()
